<template>
  <div id="content" class="eWalletList">
    <Header :title="title" :right-content="rightContent" />
    <transition name="toast-fade">
      <div v-if="toast.visible" :key="toast.key" class="copy-toast" :class="'toast-' + toast.type">
        <span class="copy-toast-message">{{ toast.message }}</span>
        <button class="copy-toast-close" type="button" aria-label="关闭提示" @click="closeToast">
          <span aria-hidden="true">×</span>
        </button>
        <span class="toast-progress-bar" aria-hidden="true" />
      </div>
    </transition>
    <div class="container">
      <div v-if="isLoadingList" class="wallet-loading">
        <p>你的电子钱包加载中</p>
        <div class="wallet-loading-spinner" />
      </div>
      <template v-else>
        <div class="prompt">
          <img src="@/assets/images/template/a_top_remind.png"><span>为了您的账户资金安全，平台仅支持绑定 {{ maxWallets }} 个电子钱包。</span>
        </div>
        <div class="wallet-list">
          <ul>
            <li v-for="(wallet, index) in walletList" :key="'e-wallet-' + wallet.id">
              <div class="wrapper wallet-wrapper">
                <transition name="dropdown-anim">
                  <div v-if="openDropdownWalletIndex === index" class="dropdown-menu">
                    <button class="danger-text" type="button" @click.stop="showUnbindConfirmation(wallet)">解绑</button>
                  </div>
                </transition>
                <div class="wallet-icon">
                  <img
                    :src="require('@/assets/images/wallet/bitcoin-white.png')"
                    alt="my e-wallet 1"
                  >
                </div>
                <div class="wallet-description">
                  <div class="wallet-heading">
                    <p>
                      <span class="wallet-protocol">{{ wallet.protocol }}</span>
                      <span class="wallet-company">{{ wallet.walletCompany }}</span>
                    </p>
                    <button
                      class="more-action"
                      type="button"
                      aria-label="钱包操作"
                      @click.stop="toggleDropdown(index)"
                    ><span aria-hidden="true">⋮</span></button>
                  </div>
                  <div class="row">
                    <!-- {{ wallet.walletAddress.replace(/(\w{6})(\w+)/, "**** $ 2") }} -->
                    <span>{{
                      wallet.walletAddress.replace(
                        /(\w{4})\w+(\w{4})/,
                        "$1****$2"
                      )
                    }}</span>
                    &nbsp;&nbsp;
                    <img
                      ref="copyButtons"
                      class="icon"
                      src="@/assets/images/wallet/copy-white.png"
                      :data-clipboard-text="wallet.walletAddress"
                    >
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="wrapper">
          <div v-if="walletList.length < maxWallets" class="add-new-wallet">
            <button @click="goToAddWallet()">添加新钱包地址</button>
            <p style="margin-top: 0.2rem">支持 ERC20 和 TRC20</p>
          </div>
        </div>
      </template>
    </div>
    <div v-if="walletToUnbind" class="unbind-modal-overlay" @click.stop>
      <div class="unbind-modal-content" role="dialog" aria-modal="true" aria-labelledby="unbind-wallet-title">
        <p id="unbind-wallet-title" class="unbind-modal-title">温馨提示</p>
        <p class="unbind-modal-msg">
          确认要解除绑定 {{ walletToUnbind.protocol }} 链电子钱包 {{ maskWalletAddress(walletToUnbind.walletAddress) }} 吗？
        </p>
        <div class="unbind-modal-actions">
          <button class="btn-cancel" type="button" :disabled="isUnbinding" @click.stop="closeUnbindConfirmation">取消</button>
          <button class="btn-confirm" type="button" :disabled="isUnbinding" @click.stop="confirmUnbind">确定</button>
        </div>
      </div>
    </div>
    <Chat />
    <AlertPop
      :model="alertPop.show"
      :content="alertPop.content"
      :button1txt="alertPop.button1Txt"
      :auto-hide-duration="alertPop.autoHideDuration"
      @alertOnClose="alertOnClose"
    />
  </div>
</template>
<script>
require('@/assets/css/eWalletList.css')
import Header from '@/view/module/Header.vue'
import Chat from '@/view/module/Chat.vue'
import api from '@/plugins/api'
import { mapState } from 'vuex'
import AlertPop from '@/view/module/AlertPop.vue'
import Clipboard from 'clipboard'
import { MAX_WALLETS } from '@/utils/constants'

export default {
  name: 'EwalletList',
  components: { Header, Chat, AlertPop },
  data() {
    return {
      title: '电子钱包管理',
      walletList: [],
      rightContent: 'isNo',
      alertPop: {
        show: false
      },
      toast: {
        visible: false,
        message: '',
        type: 'neutral',
        timer: null,
        key: 0
      },
      openDropdownWalletIndex: null,
      walletToUnbind: null,
      isUnbinding: false,
      isLoadingList: true,
      enabled: false
    }
  },
  computed: {
    ...mapState(['pageType', 'token'])
  },
  beforeCreate() {},
  created() {
    this.maxWallets = MAX_WALLETS
  },
  mounted() {
    this.$bus.$emit('loading', false)
    this.getWithdrawMethod()
  },
  beforeDestroy() {
    if (this.toast.timer) clearTimeout(this.toast.timer)
  },
  methods: {
    alertOnClose() {
      this.alertPop = {
        show: false
      }
    },
    goToAddWallet() {
      this.$router.push({ path: '/home/RegisterUSDT' })
    },
    showToast(message, type = 'neutral') {
      if (this.toast.timer) clearTimeout(this.toast.timer)
      this.toast.message = message
      this.toast.type = type
      this.toast.key += 1
      this.toast.visible = true
      this.toast.timer = setTimeout(() => this.closeToast(), 5000)
    },
    closeToast() {
      this.toast.visible = false
      if (this.toast.timer) {
        clearTimeout(this.toast.timer)
        this.toast.timer = null
      }
    },
    toggleDropdown(walletIndex) {
      this.openDropdownWalletIndex = this.openDropdownWalletIndex === walletIndex ? null : walletIndex
    },
    showUnbindConfirmation(wallet) {
      this.openDropdownWalletIndex = null
      this.walletToUnbind = wallet
    },
    closeUnbindConfirmation() {
      if (!this.isUnbinding) this.walletToUnbind = null
    },
    maskWalletAddress(walletAddress) {
      const address = String(walletAddress || '')
      if (address.length <= 8) return address
      return `${address.slice(0, 4)}****${address.slice(-4)}`
    },
    async confirmUnbind() {
      if (!this.walletToUnbind || this.isUnbinding) return

      const wallet = this.walletToUnbind
      const data = new FormData()
      data.append('walletAddress', wallet.walletAddress)
      this.walletToUnbind = null
      this.isUnbinding = true
      this.$bus.$emit('loading', false)
      let toastMessage = ''
      let toastType = 'neutral'

      try {
        const res = await api.deleteWallet(data)
        if (res && res.data && res.data.code === 200) {
          const apiMessage = res.data.data
          const successMessage = typeof apiMessage === 'string' && apiMessage.trim()
            ? apiMessage.trim()
            : '操作成功'
          toastMessage = successMessage
          await this.getWalletList()
        } else {
          toastMessage = (res && res.data && (res.data.msg || res.data.message)) || '解绑失败，请稍后重试'
          toastType = 'error'
        }
      } catch (error) {
        toastMessage = '网络或服务器异常，请稍后重试'
        toastType = 'error'
      } finally {
        this.isUnbinding = false
        this.$bus.$emit('loading', true)
        this.$nextTick(() => this.showToast(toastMessage, toastType))
      }
    },
    getWalletList() {
      this.isLoadingList = true
      return api
        .getWalletList()
        .then((res) => {
          if (res.data.code === 200) {
            this.walletList = res.data.data
          } else {
            this.alertPop = {
              show: true,
              content: '获取钱包列表失败',
              button1Txt: '知道了'
            }
          }
        })
        .catch(() => {
          this.alertPop = {
            show: true,
            content: '网络发生错误，请稍候再试',
            button1Txt: '知道了'
          }
        })
        .finally(() => {
          this.isLoadingList = false
          this.$bus.$emit('loading', true)
          this.$nextTick(() => this.appendCopyEvent())
        })
    },
    getWithdrawMethod() {
      api.getWithdrawMethod().then((res) => {
        if (res.data.code === 200) {
          this.enabled = res.data.data.fictitious
          if (this.enabled) this.getWalletList()
          else {
            this.$bus.$emit('loading', true)
            this.$router.replace({
              path: '/home'
            })
          }
        }
      })
    },
    appendCopyEvent() {
      const buttons = this.$refs.copyButtons || []
      const _this = this
      buttons.map(ele => {
        const c = new Clipboard(ele)
        c.on('success', () => {
          _this.showToast('复制成功')
        })
        c.on('error', () => {
          this.alertPop = {
            show: true,
            content: '复制失败，请手动选择复制！',
            autoHideDuration: 500
          }
        })
      })
    },
    async copyToClipboard(text) {
      if (
        window.location.protocol.match(/https/gi) && navigator.clipboard
      ) {
        await navigator.clipboard.writeText(text)
        await navigator.clipboard.readText()
        this.showToast('复制成功')
      } else {
        const textArea = document.createElement('textarea')
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
        this.showToast('复制成功')
      }
    }
  }
}
</script>
